import { scCoreModule } from '../core/core.module';
import { scFilterModule } from '../filter/filter.module';
import { scFactsModule } from '../facts/facts.module';
import { scStatModule } from '../stat/stat.module';
import { scSharedModule } from '../shared/shared.module';
import { RootCtrl } from './root';
import { SidebarComponent } from './sidebar.component';
import { scViewModule } from '../view/view.module';
import { SidebarLeftComponent } from './sidebar-left.component';
import { SidebarToggleComponent } from './sidebar-toggle.component';
import { HeaderComponent } from './header.component';
import { FooterComponent } from './footer.component';
import { scAdminModule } from '../admin/admin.module';
import { FieldsModalService } from './fields/fields-modal.service.js';
import { scFaceModule } from '../face/face.module';
import { scUsercardModule } from '../usercard/usercard.module';

export const scLayoutModule = 'sc-layout';

angular.module(scLayoutModule, [
  scFactsModule,
  scStatModule,
  scCoreModule,
  scFilterModule,
  scSharedModule,
  scViewModule,
  scAdminModule,
  scFaceModule,
  scUsercardModule
])
  .service('FieldsModalService', FieldsModalService)
  .controller('RootCtrl', RootCtrl)
  .directive('scSidebar', SidebarComponent)
  .directive('scSidebarLeft', SidebarLeftComponent)
  .component('scSidebarToggle', SidebarToggleComponent)
  .component('scHeader', HeaderComponent)
  .component('scFooter', FooterComponent)
;



// WEBPACK FOOTER //
// ./src/layout/layout.module.js